import React, { useEffect, useState } from 'react';
import ApiService from 'services/ApiService'; 
import '../../css/BISFaultReport.css';

const BISFaultReport = () => {
    const today = new Date().toISOString().split('T')[0];
    const [selectedDate, setSelectedDate] = useState(today);
    const [summaryData, setSummaryData] = useState({});
    const [tableData, setTableData] = useState([]);
    const [isLoading, setIsLoading] = useState(false); // ✅ 로딩 상태

    const summaryKeys = ['메인부', '전원부', '표출부', '통신부', 'FAN', '외함', '공사', '기타', '금일조치', '조치중'];

    const fetchData = async () => {
        const dateStr = selectedDate.replaceAll('-', '');
        setIsLoading(true); // ✅ 로딩 시작
        try {
            const response = await ApiService.get(`newdashboard/afterpack/GetBisErr?sdtm=${dateStr}&edtm=${dateStr}`);
            const { total = [], rows = [] } = response.data;

            const summaryObj = {};
            summaryKeys.forEach(key => {
                const item = total.find(t => t.codeNm === key);
                summaryObj[key] = item?.cnt ?? 0;
            });
            setSummaryData(summaryObj);

            const mappedRows = rows.map(item => ({
                정류장ID: item.stationId,
                모바일번호: item.mobileNo,
                정류장명: item.stationNm,
                장비ID: item.devId,
                중상: item.codeNm,
                조치내용: item.repairDesc,
                결과: item.repairProc === 'Y' ? '조치완료' : '조치중',
                발생일시: item.time
            }));
            setTableData(mappedRows);
        } catch (err) {
            console.error('데이터 가져오기 실패:', err);
        } finally {
            setIsLoading(false); // ✅ 로딩 종료
        }
    };

    useEffect(() => {
        fetchData();
    }, [selectedDate]);

    const tableColumns = ['정류장ID', '모바일번호', '정류장명', '장비ID', '중상', '조치내용', '결과', '발생일시'];

    return (
        <div className="bis-fault-container">
            <div className="bis-header">
                {/* 날짜 선택 */}
                <div className="date-selector" style={{flex:1}}>
                    <input
                        type="date"
                        className='date'
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        >
                    </input>
                </div>
            </div>
            {/* 요약 섹션 */}
            <div className="summary-section">
                <div className="summary-title">일일 장애현황 ({selectedDate})</div>
                <table className="summary-table">
                    <thead>
                        <tr>
                            {summaryKeys.map((column) => (
                                <th key={column}>{column}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {summaryKeys.map((column) => (
                                <td key={column}>{summaryData[column]}</td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* 상세 테이블 */}
            <div className="detail-section cst_scroll">
                <table className="detail-table">
                    <thead>
                        <tr>
                            {tableColumns.map((column) => (
                                <th key={column}>{column}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((row, index) => (
                            <tr key={index}>
                                {tableColumns.map((column) => (
                                    <td key={column}>{row[column]}</td>
                                ))}
                            </tr>
                        ))}
                        {tableData.length === 0 && !isLoading && (
                            <tr>
                                <td colSpan={tableColumns.length}>
                                    데이터가 없습니다.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {/* ✅ 로딩 표시 */}
                {isLoading && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
                        <div className="loading-spinner" />
                        <div className="table-loading">로딩 중입니다...</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BISFaultReport;